import { redirect, type LoaderFunctionArgs } from 'react-router-dom'

import { useAuthStore } from '@/stores/auth.store'

export const authGuard = async ({ request }: LoaderFunctionArgs) => {
  const { accessToken } = useAuthStore.getState()

  if (!accessToken) {
    const url = new URL(request.url)
    const redirectTo = `${url.pathname}${url.search}`
    throw redirect(`/login?redirect=${encodeURIComponent(redirectTo)}`)
  }

  return null
}
